module.exports = __webpack_public_path__ + "static/media/signin-user.3e0f8f26.png";